export const STATES = {
  LOADING: "LOADING",
  OK: "OK",
};
